/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddEmailRequest } from '../models/AddEmailRequest';
import type { AddPlayersToLeagueRequest } from '../models/AddPlayersToLeagueRequest';
import type { AllowlistEntry } from '../models/AllowlistEntry';
import type { AsyncJobResponse } from '../models/AsyncJobResponse';
import type { AverageDurationResponse } from '../models/AverageDurationResponse';
import type { ChatRequest } from '../models/ChatRequest';
import type { ChatResponse } from '../models/ChatResponse';
import type { ClaimedPlayer } from '../models/ClaimedPlayer';
import type { CommentatorSummary } from '../models/CommentatorSummary';
import type { CreateInviteRequest } from '../models/CreateInviteRequest';
import type { CreatePlayerRequest } from '../models/CreatePlayerRequest';
import type { CustomRuleInput } from '../models/CustomRuleInput';
import type { CustomRuleOutput } from '../models/CustomRuleOutput';
import type { DeleteFilesRequest } from '../models/DeleteFilesRequest';
import type { EnrichedUnclaimedPlayer } from '../models/EnrichedUnclaimedPlayer';
import type { GameFileInfo } from '../models/GameFileInfo';
import type { GameInput } from '../models/GameInput';
import type { GameOutput } from '../models/GameOutput';
import type { GameRulesOutput } from '../models/GameRulesOutput';
import type { GameUpdateInput } from '../models/GameUpdateInput';
import type { ImportOnlineRulesRequest } from '../models/ImportOnlineRulesRequest';
import type { InviteEntry } from '../models/InviteEntry';
import type { JobStatusOutput } from '../models/JobStatusOutput';
import type { LeagueDetail } from '../models/LeagueDetail';
import type { LeagueInput } from '../models/LeagueInput';
import type { LeagueOutput } from '../models/LeagueOutput';
import type { LeaguePlayer } from '../models/LeaguePlayer';
import type { LeagueUpdateInput } from '../models/LeagueUpdateInput';
import type { OnboardingResponse } from '../models/OnboardingResponse';
import type { OnlineRulesResult } from '../models/OnlineRulesResult';
import type { Player } from '../models/Player';
import type { PlayerLeagueMembership } from '../models/PlayerLeagueMembership';
import type { PlayerWithLeagueContext } from '../models/PlayerWithLeagueContext';
import type { PlayInput } from '../models/PlayInput';
import type { PlayOutput } from '../models/PlayOutput';
import type { PlayStats } from '../models/PlayStats';
import type { PlayUpdateInput } from '../models/PlayUpdateInput';
import type { PresignedDownloadUrlResponse } from '../models/PresignedDownloadUrlResponse';
import type { PresignedUrlRequest } from '../models/PresignedUrlRequest';
import type { PresignedUrlResponse } from '../models/PresignedUrlResponse';
import type { RatingHistory } from '../models/RatingHistory';
import type { ReactionInput } from '../models/ReactionInput';
import type { ReactionOutput } from '../models/ReactionOutput';
import type { ReactionsResponse } from '../models/ReactionsResponse';
import type { RemoveEmailRequest } from '../models/RemoveEmailRequest';
import type { StrategyGuideOutput } from '../models/StrategyGuideOutput';
import type { TagSuggestions } from '../models/TagSuggestions';
import type { TagSuggestionsRequest } from '../models/TagSuggestionsRequest';
import type { TelemetryAccepted } from '../models/TelemetryAccepted';
import type { TelemetryEventBatch } from '../models/TelemetryEventBatch';
import type { TelemetryPreferences } from '../models/TelemetryPreferences';
import type { TelemetryReplayChunk } from '../models/TelemetryReplayChunk';
import type { TokenResponse } from '../models/TokenResponse';
import type { UsageEventRecord } from '../models/UsageEventRecord';
import type { UsageReplay } from '../models/UsageReplay';
import type { UsageSession } from '../models/UsageSession';
import type { UsageSummary } from '../models/UsageSummary';
import type { VoiceChatResponse } from '../models/VoiceChatResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DefaultService {
    /**
     * Get Allowlist
     * Get all emails in the authentication allowlist
     * @returns AllowlistEntry Successful Response
     * @throws ApiError
     */
    public static getAllowlistAdminAllowlistGet(): CancelablePromise<Array<AllowlistEntry>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/allowlist',
            errors: {
                500: `Server error`,
            },
        });
    }
    /**
     * Add Email to Allowlist
     * Add an email address to the authentication allowlist
     * @returns AllowlistEntry Successful Response
     * @throws ApiError
     */
    public static addEmailToAllowlistAdminAllowlistPost({
        requestBody,
    }: {
        requestBody: AddEmailRequest,
    }): CancelablePromise<AllowlistEntry> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/allowlist',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Email already exists in allowlist or invalid email format`,
                500: `Server error`,
            },
        });
    }
    /**
     * Remove Email from Allowlist
     * Remove an email address from the authentication allowlist
     * @returns any Successful Response
     * @throws ApiError
     */
    public static removeEmailFromAllowlistAdminAllowlistDelete({
        requestBody,
    }: {
        requestBody: RemoveEmailRequest,
    }): CancelablePromise<{
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/allowlist',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Email not found in allowlist`,
                500: `Server error`,
            },
        });
    }
    /**
     * Create Invite
     * Create a new time-limited invite link
     * @returns InviteEntry Successful Response
     * @throws ApiError
     */
    public static createInviteAdminInvitesPost({
        requestBody,
    }: {
        requestBody: CreateInviteRequest,
    }): CancelablePromise<InviteEntry> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/admin/invites',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                500: `Server error`,
            },
        });
    }
    /**
     * List Invites
     * List all invites with active/expired status
     * @returns InviteEntry Successful Response
     * @throws ApiError
     */
    public static listInvitesAdminInvitesGet(): CancelablePromise<Array<InviteEntry>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/invites',
            errors: {
                500: `Server error`,
            },
        });
    }
    /**
     * Delete Invite
     * Delete/revoke an invite
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteInviteAdminInvitesTokenDelete({
        token,
    }: {
        token: string,
    }): CancelablePromise<{
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/invites/{token}',
            path: {
                'token': token,
            },
            errors: {
                404: `Invite not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Get Claimed Players
     * Get all players that have been claimed (have an email address associated)
     * @returns ClaimedPlayer Successful Response
     * @throws ApiError
     */
    public static getClaimedPlayersAdminPlayersClaimedGet(): CancelablePromise<Array<ClaimedPlayer>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/players/claimed',
            errors: {
                500: `Server error`,
            },
        });
    }
    /**
     * Unclaim Player Profile
     * Remove the email address association from a player profile
     * @returns any Successful Response
     * @throws ApiError
     */
    public static unclaimPlayerProfileAdminPlayersPlayerIdUnclaimDelete({
        playerId,
    }: {
        playerId: string,
    }): CancelablePromise<{
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/admin/players/{player_id}/unclaim',
            path: {
                'player_id': playerId,
            },
            errors: {
                404: `Player not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Get Games
     * @returns GameOutput Successful Response
     * @throws ApiError
     */
    public static getGamesGamesGet(): CancelablePromise<Array<GameOutput>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/games',
        });
    }
    /**
     * Create Game
     * @returns GameOutput Successful Response
     * @throws ApiError
     */
    public static createGameGamesPost({
        requestBody,
    }: {
        requestBody?: GameInput,
    }): CancelablePromise<GameOutput> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/games',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Game
     * @returns GameOutput Successful Response
     * @throws ApiError
     */
    public static getGameGamesGameIdGet({
        gameId,
    }: {
        gameId: string,
    }): CancelablePromise<GameOutput> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/games/{game_id}',
            path: {
                'game_id': gameId,
            },
        });
    }
    /**
     * Update Game
     * @returns GameOutput Successful Response
     * @throws ApiError
     */
    public static updateGameGamesGameIdPut({
        gameId,
        requestBody,
    }: {
        gameId: string,
        requestBody?: GameUpdateInput,
    }): CancelablePromise<GameOutput> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/games/{game_id}',
            path: {
                'game_id': gameId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Game
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteGameGamesGameIdDelete({
        gameId,
    }: {
        gameId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/games/{game_id}',
            path: {
                'game_id': gameId,
            },
        });
    }
    /**
     * Upload Game Image
     * @returns GameOutput Successful Response
     * @throws ApiError
     */
    public static uploadGameImageGamesGameIdImagePost({
        gameId,
        formData,
    }: {
        gameId: string,
        formData?: {
            image?: Blob;
        },
    }): CancelablePromise<GameOutput> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/games/{game_id}/image',
            path: {
                'game_id': gameId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Get Game Plays
     * @returns PlayOutput Successful Response
     * @throws ApiError
     */
    public static getGamePlaysGamesGameIdPlaysGet({
        gameId,
    }: {
        gameId: string,
    }): CancelablePromise<Array<PlayOutput>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/games/{game_id}/plays',
            path: {
                'game_id': gameId,
            },
        });
    }
    /**
     * Get Game Rules
     * Get rules summary and metadata for a game
     * @returns GameRulesOutput Successful Response
     * @throws ApiError
     */
    public static getGameRulesGamesGameIdRulesGet({
        gameId,
    }: {
        gameId: string,
    }): CancelablePromise<GameRulesOutput> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/games/{game_id}/rules',
            path: {
                'game_id': gameId,
            },
            errors: {
                404: `Game not found`,
            },
        });
    }
    /**
     * Notify Rules PDF Upload Complete
     * Notify the server that a rules PDF has been uploaded to S3. This triggers the async processing of the PDF.
     * @returns AsyncJobResponse PDF processing initiated.
     * @throws ApiError
     */
    public static notifyRulesPdfUploadCompleteGamesGameIdRulesUploadPut({
        gameId,
        s3Key,
        type,
        expansionName,
    }: {
        gameId: string,
        s3Key: string,
        type: 'base' | 'expansion',
        expansionName?: string,
    }): CancelablePromise<AsyncJobResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/games/{game_id}/rules/upload',
            path: {
                'game_id': gameId,
            },
            query: {
                's3_key': s3Key,
                'type': type,
                'expansionName': expansionName,
            },
            errors: {
                400: `Invalid request`,
                404: `Game not found`,
            },
        });
    }
    /**
     * Get Presigned URL for Rules PDF Upload
     * Get a presigned URL to upload a rules PDF directly to S3.
     * @returns PresignedUrlResponse Successful Response
     * @throws ApiError
     */
    public static getPresignedUrlForRulesPdfUploadGamesGameIdRulesUploadUrlPost({
        gameId,
        requestBody,
    }: {
        gameId: string,
        requestBody: PresignedUrlRequest,
    }): CancelablePromise<PresignedUrlResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/games/{game_id}/rules/upload-url',
            path: {
                'game_id': gameId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
                404: `Game not found`,
            },
        });
    }
    /**
     * List Game Files
     * List all files (PDFs, extracted text, summaries) associated with a game
     * @returns GameFileInfo Successful Response
     * @throws ApiError
     */
    public static listGameFilesGamesGameIdRulesFilesGet({
        gameId,
    }: {
        gameId: string,
    }): CancelablePromise<Array<GameFileInfo>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/games/{game_id}/rules/files',
            path: {
                'game_id': gameId,
            },
            errors: {
                404: `Game not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Delete Game Files
     * Delete one or more files associated with a game. Also deletes files from S3.
     * @returns any Files deleted successfully
     * @throws ApiError
     */
    public static deleteGameFilesGamesGameIdRulesFilesDelete({
        gameId,
        requestBody,
    }: {
        gameId: string,
        requestBody: DeleteFilesRequest,
    }): CancelablePromise<{
        message?: string;
        deletedCount?: number;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/games/{game_id}/rules/files',
            path: {
                'game_id': gameId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Forbidden`,
                500: `Server error`,
            },
        });
    }
    /**
     * Get Presigned URL for Rules File Download
     * Get a presigned URL to download a rules file from S3.
     * @returns PresignedDownloadUrlResponse Successful Response
     * @throws ApiError
     */
    public static getPresignedUrlForRulesPdfDownloadGamesGameIdRulesFilesFileIdDownloadUrlGet({
        gameId,
        fileId,
    }: {
        gameId: string,
        fileId: string,
    }): CancelablePromise<PresignedDownloadUrlResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/games/{game_id}/rules/files/{file_id}/download-url',
            path: {
                'game_id': gameId,
                'file_id': fileId,
            },
            errors: {
                404: `Game or file not found`,
            },
        });
    }
    /**
     * Search Online Rules (No Game)
     * Search for game rules on Ultra Board Games without requiring a game ID
     * @returns OnlineRulesResult Successful Response
     * @throws ApiError
     */
    public static searchOnlineRulesNoGameRulesSearchOnlineGet({
        query,
    }: {
        /**
         * Game name to search for
         */
        query: string,
    }): CancelablePromise<Array<OnlineRulesResult>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/rules/search-online',
            query: {
                'query': query,
            },
            errors: {
                500: `Server error`,
            },
        });
    }
    /**
     * Search Online Rules
     * Search for game rules on Ultra Board Games
     * @returns OnlineRulesResult Successful Response
     * @throws ApiError
     */
    public static searchOnlineRulesGamesGameIdRulesSearchOnlineGet({
        gameId,
        query,
    }: {
        gameId: string,
        /**
         * Game name to search for
         */
        query: string,
    }): CancelablePromise<Array<OnlineRulesResult>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/games/{game_id}/rules/search-online',
            path: {
                'game_id': gameId,
            },
            query: {
                'query': query,
            },
            errors: {
                404: `Game not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Import Online Rules
     * Import rules from Ultra Board Games for a game
     * @returns AsyncJobResponse Rules import initiated
     * @throws ApiError
     */
    public static importOnlineRulesGamesGameIdRulesImportOnlinePost({
        gameId,
        requestBody,
    }: {
        gameId: string,
        requestBody: ImportOnlineRulesRequest,
    }): CancelablePromise<AsyncJobResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/games/{game_id}/rules/import-online',
            path: {
                'game_id': gameId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Game not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Generate Rules Summary (Async)
     * Generate or regenerate AI-powered rules summary from uploaded PDF asynchronously. Returns job_id immediately. Summary will be generated in background.
     * @returns AsyncJobResponse Summary generation initiated. Processing in background.
     * @throws ApiError
     */
    public static generateRulesSummaryGamesGameIdRulesGenerateSummaryPost({
        gameId,
    }: {
        gameId: string,
    }): CancelablePromise<AsyncJobResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/games/{game_id}/rules/generate-summary',
            path: {
                'game_id': gameId,
            },
            errors: {
                400: `No rules uploaded yet`,
                404: `Game not found`,
                500: `AI service error`,
            },
        });
    }
    /**
     * List Custom Rules
     * List all custom/house rules for a game
     * @returns CustomRuleOutput Successful Response
     * @throws ApiError
     */
    public static listCustomRulesGamesGameIdRulesCustomGet({
        gameId,
    }: {
        gameId: string,
    }): CancelablePromise<Array<CustomRuleOutput>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/games/{game_id}/rules/custom',
            path: {
                'game_id': gameId,
            },
            errors: {
                404: `Game not found`,
            },
        });
    }
    /**
     * Create Custom Rule
     * Create a new custom/house rule for a game
     * @returns CustomRuleOutput Successful Response
     * @throws ApiError
     */
    public static createCustomRuleGamesGameIdRulesCustomPost({
        gameId,
        requestBody,
    }: {
        gameId: string,
        requestBody: CustomRuleInput,
    }): CancelablePromise<CustomRuleOutput> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/games/{game_id}/rules/custom',
            path: {
                'game_id': gameId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
                404: `Game not found`,
            },
        });
    }
    /**
     * Update Custom Rule
     * Update an existing custom/house rule
     * @returns CustomRuleOutput Successful Response
     * @throws ApiError
     */
    public static updateCustomRuleGamesGameIdRulesCustomRuleIdPut({
        gameId,
        ruleId,
        requestBody,
    }: {
        gameId: string,
        ruleId: string,
        requestBody: CustomRuleInput,
    }): CancelablePromise<CustomRuleOutput> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/games/{game_id}/rules/custom/{rule_id}',
            path: {
                'game_id': gameId,
                'rule_id': ruleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
                404: `Game or rule not found`,
            },
        });
    }
    /**
     * Delete Custom Rule
     * Delete a custom/house rule
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteCustomRuleGamesGameIdRulesCustomRuleIdDelete({
        gameId,
        ruleId,
    }: {
        gameId: string,
        ruleId: string,
    }): CancelablePromise<{
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/games/{game_id}/rules/custom/{rule_id}',
            path: {
                'game_id': gameId,
                'rule_id': ruleId,
            },
            errors: {
                404: `Game or rule not found`,
            },
        });
    }
    /**
     * Get Strategy Guide
     * Get AI-generated strategy guide for a game
     * @returns StrategyGuideOutput Successful Response
     * @throws ApiError
     */
    public static getStrategyGuideGamesGameIdStrategyGet({
        gameId,
    }: {
        gameId: string,
    }): CancelablePromise<StrategyGuideOutput> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/games/{game_id}/strategy',
            path: {
                'game_id': gameId,
            },
            errors: {
                404: `Game not found`,
            },
        });
    }
    /**
     * Generate Strategy Guide (Async)
     * Generate AI-powered strategy guide from rules asynchronously. Returns job_id immediately. Strategy guide will be generated in background.
     * @returns AsyncJobResponse Strategy generation initiated. Processing in background.
     * @throws ApiError
     */
    public static generateStrategyGuideGamesGameIdStrategyGeneratePost({
        gameId,
    }: {
        gameId: string,
    }): CancelablePromise<AsyncJobResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/games/{game_id}/strategy/generate',
            path: {
                'game_id': gameId,
            },
            errors: {
                400: `No rules uploaded yet`,
                404: `Game not found`,
                500: `AI service error`,
            },
        });
    }
    /**
     * Get Tag Suggestions
     * Get AI-generated tag suggestions for a board game
     * @returns TagSuggestions Successful Response
     * @throws ApiError
     */
    public static getTagSuggestionsGamesGameIdTagSuggestionsGet({
        gameId,
    }: {
        gameId: string,
    }): CancelablePromise<TagSuggestions> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/games/{game_id}/tag-suggestions',
            path: {
                'game_id': gameId,
            },
            errors: {
                404: `Game not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Get Metadata Field Options
     * Get all previously used values for each metadata field (for autocomplete)
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getMetadataFieldOptionsGamesGameIdMetadataOptionsGet({
        gameId,
    }: {
        gameId: string,
    }): CancelablePromise<Record<string, Array<string>>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/games/{game_id}/metadata-options',
            path: {
                'game_id': gameId,
            },
            errors: {
                404: `Game not found`,
            },
        });
    }
    /**
     * Get Average Game Duration
     * Get average play duration for a game, optionally filtered by player count
     * @returns AverageDurationResponse Successful Response
     * @throws ApiError
     */
    public static getAverageDurationGamesGameIdAverageDurationGet({
        gameId,
        playerCount,
    }: {
        gameId: string,
        /**
         * Filter by number of players to get more accurate estimate
         */
        playerCount?: number,
    }): CancelablePromise<AverageDurationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/games/{game_id}/average-duration',
            path: {
                'game_id': gameId,
            },
            query: {
                'player_count': playerCount,
            },
            errors: {
                404: `Game not found`,
            },
        });
    }
    /**
     * Get Tag Suggestions by Name
     * Get AI-generated tag suggestions for a board game by name
     * @returns TagSuggestions Successful Response
     * @throws ApiError
     */
    public static getTagSuggestionsByNameGamesTagSuggestionsByNamePost({
        requestBody,
    }: {
        requestBody?: TagSuggestionsRequest,
    }): CancelablePromise<TagSuggestions> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/games/tag-suggestions-by-name',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request - game name required`,
                500: `Server error`,
            },
        });
    }
    /**
     * Send Chat Message
     * Send a chat message to the AI assistant and get a response
     * @returns ChatResponse Successful Response
     * @throws ApiError
     */
    public static sendChatMessageGamesGameIdChatPost({
        gameId,
        requestBody,
    }: {
        gameId: string,
        requestBody: ChatRequest,
    }): CancelablePromise<ChatResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/games/{game_id}/chat',
            path: {
                'game_id': gameId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `No rules uploaded yet`,
                404: `Game not found`,
                500: `AI service error`,
            },
        });
    }
    /**
     * Voice Chat with AI Assistant
     * Send an audio recording to the AI assistant and get a text + audio response
     * @returns VoiceChatResponse Successful Response
     * @throws ApiError
     */
    public static voiceChatGamesGameIdVoiceChatPost({
        gameId,
        formData,
    }: {
        gameId: string,
        formData: {
            /**
             * Audio recording (webm, mp4, or wav)
             */
            audio: Blob;
            /**
             * JSON-encoded conversation history array
             */
            conversation_history?: string;
        },
    }): CancelablePromise<VoiceChatResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/games/{game_id}/voice-chat',
            path: {
                'game_id': gameId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `No rules uploaded or invalid audio`,
                404: `Game not found`,
                500: `AI service error`,
            },
        });
    }
    /**
     * Get Leagues
     * @returns LeagueOutput Successful Response
     * @throws ApiError
     */
    public static getLeaguesLeaguesGet({
        includeGameSpecific = false,
    }: {
        /**
         * Whether to include game-specific leagues in the response
         */
        includeGameSpecific?: boolean,
    }): CancelablePromise<Array<LeagueOutput>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/leagues',
            query: {
                'includeGameSpecific': includeGameSpecific,
            },
        });
    }
    /**
     * Create League
     * @returns LeagueOutput Successful Response
     * @throws ApiError
     */
    public static createLeagueLeaguesPost({
        requestBody,
    }: {
        requestBody: LeagueInput,
    }): CancelablePromise<LeagueOutput> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/leagues',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
                500: `Server error`,
            },
        });
    }
    /**
     * Get League
     * @returns LeagueDetail Successful Response
     * @throws ApiError
     */
    public static getLeagueLeaguesLeagueIdGet({
        leagueId,
    }: {
        leagueId: string,
    }): CancelablePromise<LeagueDetail> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/leagues/{league_id}',
            path: {
                'league_id': leagueId,
            },
            errors: {
                404: `League not found`,
            },
        });
    }
    /**
     * Update League
     * @returns LeagueOutput Successful Response
     * @throws ApiError
     */
    public static updateLeagueLeaguesLeagueIdPut({
        leagueId,
        requestBody,
    }: {
        leagueId: string,
        requestBody: LeagueUpdateInput,
    }): CancelablePromise<LeagueOutput> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/leagues/{league_id}',
            path: {
                'league_id': leagueId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request - cannot modify Global league`,
                404: `League not found`,
            },
        });
    }
    /**
     * Delete League
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deleteLeagueLeaguesLeagueIdDelete({
        leagueId,
    }: {
        leagueId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/leagues/{league_id}',
            path: {
                'league_id': leagueId,
            },
            errors: {
                400: `Invalid request - cannot delete Global league`,
                404: `League not found`,
            },
        });
    }
    /**
     * Get League Players
     * @returns LeaguePlayer Successful Response
     * @throws ApiError
     */
    public static getLeaguePlayersLeaguesLeagueIdPlayersGet({
        leagueId,
    }: {
        leagueId: string,
    }): CancelablePromise<Array<LeaguePlayer>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/leagues/{league_id}/players',
            path: {
                'league_id': leagueId,
            },
            errors: {
                404: `League not found`,
            },
        });
    }
    /**
     * Add Players to League
     * @returns any Successful Response
     * @throws ApiError
     */
    public static addPlayersToLeagueLeaguesLeagueIdPlayersPost({
        leagueId,
        requestBody,
    }: {
        leagueId: string,
        requestBody: AddPlayersToLeagueRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/leagues/{league_id}/players',
            path: {
                'league_id': leagueId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
                404: `League not found`,
            },
        });
    }
    /**
     * Remove Player from League
     * @returns any Successful Response
     * @throws ApiError
     */
    public static removePlayerFromLeagueLeaguesLeagueIdPlayersPlayerIdDelete({
        leagueId,
        playerId,
    }: {
        leagueId: string,
        playerId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/leagues/{league_id}/players/{player_id}',
            path: {
                'league_id': leagueId,
                'player_id': playerId,
            },
            errors: {
                400: `Invalid request - cannot remove players from Global league`,
                404: `League or player not found`,
            },
        });
    }
    /**
     * Get Rating Histories in League
     * Rating histories of several players in one request. Returns every league member unless playerIds is given.
     * @returns RatingHistory Successful Response
     * @throws ApiError
     */
    public static getLeagueRatingHistoriesLeaguesLeagueIdRatingHistoriesGet({
        leagueId,
        playerIds,
    }: {
        leagueId: string,
        /**
         * Comma-separated player IDs (defaults to all league members)
         */
        playerIds?: string,
    }): CancelablePromise<Array<RatingHistory>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/leagues/{league_id}/rating-histories',
            path: {
                'league_id': leagueId,
            },
            query: {
                'playerIds': playerIds,
            },
            errors: {
                404: `League not found`,
            },
        });
    }
    /**
     * Get Player Rating History in League
     * @returns RatingHistory Successful Response
     * @throws ApiError
     */
    public static getPlayerRatingHistoryInLeagueLeaguesLeagueIdPlayersPlayerIdRatingHistoryGet({
        leagueId,
        playerId,
    }: {
        leagueId: string,
        playerId: string,
    }): CancelablePromise<RatingHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/leagues/{league_id}/players/{player_id}/rating-history',
            path: {
                'league_id': leagueId,
                'player_id': playerId,
            },
            errors: {
                404: `League or player not found`,
            },
        });
    }
    /**
     * Get Job Status
     * Get status and results of an async processing job (PDF processing, strategy generation, etc.)
     * @returns JobStatusOutput Successful Response
     * @throws ApiError
     */
    public static getJobStatusJobsJobIdGet({
        jobId,
    }: {
        jobId: string,
    }): CancelablePromise<JobStatusOutput> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobs/{job_id}',
            path: {
                'job_id': jobId,
            },
            errors: {
                404: `Job not found`,
            },
        });
    }
    /**
     * Get Tags
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getTagsTagsGet(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/tags',
        });
    }
    /**
     * Get Owners
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getOwnersOwnersGet(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/owners',
        });
    }
    /**
     * Get Player Leagues
     * @returns PlayerLeagueMembership Successful Response
     * @throws ApiError
     */
    public static getPlayerLeaguesPlayersPlayerIdLeaguesGet({
        playerId,
        includeGameSpecific = false,
    }: {
        playerId: string,
        /**
         * Include game-specific leagues in results (defaults to false)
         */
        includeGameSpecific?: boolean,
    }): CancelablePromise<Array<PlayerLeagueMembership>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/players/{player_id}/leagues',
            path: {
                'player_id': playerId,
            },
            query: {
                'include_game_specific': includeGameSpecific,
            },
            errors: {
                404: `Player not found`,
            },
        });
    }
    /**
     * Get Players
     * @returns Player Successful Response
     * @throws ApiError
     */
    public static getPlayersPlayersGet(): CancelablePromise<Array<Player>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/players',
        });
    }
    /**
     * Create Player
     * @returns PlayerWithLeagueContext Successful Response
     * @throws ApiError
     */
    public static createPlayerPlayersPost({
        requestBody,
    }: {
        requestBody?: CreatePlayerRequest,
    }): CancelablePromise<PlayerWithLeagueContext> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/players',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                409: `Player name already exists`,
            },
        });
    }
    /**
     * Get Player
     * @returns PlayerWithLeagueContext Successful Response
     * @throws ApiError
     */
    public static getPlayerPlayersPlayerIdGet({
        playerId,
        leagueId,
    }: {
        playerId: string,
        /**
         * League ID to get player's rating in specific league context (optional)
         */
        leagueId?: string,
    }): CancelablePromise<PlayerWithLeagueContext> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/players/{player_id}',
            path: {
                'player_id': playerId,
            },
            query: {
                'league_id': leagueId,
            },
        });
    }
    /**
     * Update Player
     * @returns Player Successful Response
     * @throws ApiError
     */
    public static updatePlayerPlayersPlayerIdPut({
        playerId,
        requestBody,
    }: {
        playerId: string,
        requestBody?: CreatePlayerRequest,
    }): CancelablePromise<Player> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/players/{player_id}',
            path: {
                'player_id': playerId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                409: `Player name already exists`,
            },
        });
    }
    /**
     * Delete Player
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deletePlayerPlayersPlayerIdDelete({
        playerId,
    }: {
        playerId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/players/{player_id}',
            path: {
                'player_id': playerId,
            },
        });
    }
    /**
     * Upload Player Image
     * @returns Player Successful Response
     * @throws ApiError
     */
    public static uploadPlayerImagePlayersPlayerIdImagePost({
        playerId,
        formData,
    }: {
        playerId: string,
        formData?: {
            image?: Blob;
        },
    }): CancelablePromise<Player> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/players/{player_id}/image',
            path: {
                'player_id': playerId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Get Current User Player
     * Get the current authenticated user's player profile. Requires JWT authentication.
     * @returns PlayerWithLeagueContext Successful Response
     * @throws ApiError
     */
    public static getCurrentUserPlayerPlayersMeGet(): CancelablePromise<PlayerWithLeagueContext> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/players/me',
            errors: {
                401: `Unauthorized - authentication required`,
                404: `Player profile not found - user needs to complete onboarding`,
            },
        });
    }
    /**
     * Get Unclaimed Players with Stats
     * Get all players without email addresses (unclaimed profiles) enriched with rating, league count, and play count for onboarding UI
     * @returns EnrichedUnclaimedPlayer Successful Response
     * @throws ApiError
     */
    public static getUnclaimedPlayersPlayersUnclaimedGet(): CancelablePromise<Array<EnrichedUnclaimedPlayer>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/players/unclaimed',
        });
    }
    /**
     * Claim Player Profile
     * Claims a player profile for the authenticated user during onboarding. Requires JWT authentication.
     * @returns Player Successful Response
     * @throws ApiError
     */
    public static claimPlayerProfilePlayersPlayerIdClaimPost({
        playerId,
    }: {
        playerId: string,
    }): CancelablePromise<Player> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/players/{player_id}/claim',
            path: {
                'player_id': playerId,
            },
            errors: {
                400: `Player already claimed or user has already claimed a player`,
                401: `Unauthorized - authentication required`,
                404: `Player not found`,
            },
        });
    }
    /**
     * Generate AI Commentator Summary
     * Generate a TV sports commentator-style analysis of player performance using AI
     * @returns CommentatorSummary Successful Response
     * @throws ApiError
     */
    public static generateCommentatorSummaryPlayersPlayerIdCommentatorSummaryPost({
        playerId,
    }: {
        playerId: string,
    }): CancelablePromise<CommentatorSummary> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/players/{player_id}/commentator-summary',
            path: {
                'player_id': playerId,
            },
            errors: {
                404: `Player not found`,
                500: `AI service error`,
            },
        });
    }
    /**
     * Get Player Rating History
     * @returns RatingHistory Successful Response
     * @throws ApiError
     */
    public static getPlayerRatingHistoryPlayersPlayerIdRatingHistoryGet({
        playerId,
        leagueId,
    }: {
        playerId: string,
        /**
         * League ID to get rating history for (defaults to Global league)
         */
        leagueId?: string,
    }): CancelablePromise<RatingHistory> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/players/{player_id}/rating-history',
            path: {
                'player_id': playerId,
            },
            query: {
                'league_id': leagueId,
            },
            errors: {
                404: `Player not found`,
            },
        });
    }
    /**
     * Get Plays
     * @returns PlayOutput Successful Response
     * @throws ApiError
     */
    public static getPlaysPlaysGet({
        playerId,
        gameId,
        leagueId,
        limit = 50,
        offset,
        sort = 'newest',
    }: {
        /**
         * Filter plays by specific player ID
         */
        playerId?: string,
        /**
         * Filter plays by specific game ID
         */
        gameId?: string,
        /**
         * Filter plays by specific league ID
         */
        leagueId?: string,
        /**
         * Maximum number of plays to return
         */
        limit?: number,
        /**
         * Number of plays to skip for pagination
         */
        offset?: number,
        /**
         * Sort order for plays
         */
        sort?: 'newest' | 'oldest',
    }): CancelablePromise<Array<PlayOutput>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/plays',
            query: {
                'player_id': playerId,
                'game_id': gameId,
                'league_id': leagueId,
                'limit': limit,
                'offset': offset,
                'sort': sort,
            },
        });
    }
    /**
     * Create Play
     * @returns PlayOutput Successful Response
     * @throws ApiError
     */
    public static createPlayPlaysPost({
        requestBody,
    }: {
        requestBody?: PlayInput,
    }): CancelablePromise<PlayOutput> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/plays',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Play Statistics
     * @returns PlayStats Successful Response
     * @throws ApiError
     */
    public static getPlayStats({
        leagueId,
    }: {
        /**
         * Filter stats by league ID
         */
        leagueId?: string,
    }): CancelablePromise<PlayStats> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/plays/stats',
            query: {
                'league_id': leagueId,
            },
        });
    }
    /**
     * Get Play
     * @returns PlayOutput Successful Response
     * @throws ApiError
     */
    public static getPlayPlaysPlayIdGet({
        playId,
    }: {
        playId: string,
    }): CancelablePromise<PlayOutput> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/plays/{play_id}',
            path: {
                'play_id': playId,
            },
        });
    }
    /**
     * Update Play
     * @returns PlayOutput Successful Response
     * @throws ApiError
     */
    public static updatePlayPlaysPlayIdPut({
        playId,
        requestBody,
    }: {
        playId: string,
        requestBody?: PlayUpdateInput,
    }): CancelablePromise<PlayOutput> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/plays/{play_id}',
            path: {
                'play_id': playId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete Play
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deletePlayPlaysPlayIdDelete({
        playId,
    }: {
        playId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/plays/{play_id}',
            path: {
                'play_id': playId,
            },
        });
    }
    /**
     * Upload Play Images
     * @returns PlayOutput Successful Response
     * @throws ApiError
     */
    public static uploadPlayImagesPlaysPlayIdImagesPost({
        playId,
        formData,
    }: {
        playId: string,
        formData?: {
            images?: Array<Blob>;
        },
    }): CancelablePromise<PlayOutput> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/plays/{play_id}/images',
            path: {
                'play_id': playId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * Delete Play Images
     * @returns any Successful Response
     * @throws ApiError
     */
    public static deletePlayImagesPlaysPlayIdImagesDelete({
        playId,
        requestBody,
    }: {
        playId: string,
        requestBody?: Array<string>,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/plays/{play_id}/images',
            path: {
                'play_id': playId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Play Win Probabilities
     * Get win probabilities for all teams in a play session based on pre-game ratings
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getPlayWinProbabilitiesPlaysPlayIdWinProbabilitiesGet({
        playId,
        leagueId,
    }: {
        playId: string,
        /**
         * League ID to calculate probabilities using league-specific ratings (optional)
         */
        leagueId?: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/plays/{play_id}/win-probabilities',
            path: {
                'play_id': playId,
            },
            query: {
                'league_id': leagueId,
            },
        });
    }
    /**
     * Get Reactions Batch
     * Get reactions for multiple play sessions in a single request
     * @returns ReactionsResponse Successful Response
     * @throws ApiError
     */
    public static getReactionsBatchPlaysReactionsBatchGet({
        playIds,
    }: {
        /**
         * Comma-separated list of play IDs (max 50)
         */
        playIds: string,
    }): CancelablePromise<Record<string, ReactionsResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/plays/reactions/batch',
            query: {
                'play_ids': playIds,
            },
            errors: {
                400: `Invalid request (no play_ids or too many)`,
                500: `Server error`,
            },
        });
    }
    /**
     * Get Play Reactions
     * Get all reactions for a play session with summary
     * @returns ReactionsResponse Successful Response
     * @throws ApiError
     */
    public static getPlayReactionsPlaysPlayIdReactionsGet({
        playId,
    }: {
        playId: string,
    }): CancelablePromise<ReactionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/plays/{play_id}/reactions',
            path: {
                'play_id': playId,
            },
            errors: {
                404: `Play not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Add or Update Reaction
     * Add or update a reaction to a play session
     * @returns ReactionOutput Successful Response
     * @throws ApiError
     */
    public static addReactionPlaysPlayIdReactionsPost({
        playId,
        requestBody,
    }: {
        playId: string,
        requestBody: ReactionInput,
    }): CancelablePromise<ReactionOutput> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/plays/{play_id}/reactions',
            path: {
                'play_id': playId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid emoji type`,
                401: `Unauthorized`,
                403: `User has no player profile - redirect to onboarding`,
                404: `Play not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Remove Reaction
     * Remove a reaction from a play session
     * @returns any Successful Response
     * @throws ApiError
     */
    public static removeReactionPlaysPlayIdReactionsDelete({
        playId,
    }: {
        playId: string,
    }): CancelablePromise<{
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/plays/{play_id}/reactions',
            path: {
                'play_id': playId,
            },
            errors: {
                401: `Unauthorized`,
                403: `User has no player profile`,
                404: `Reaction not found`,
                500: `Server error`,
            },
        });
    }
    /**
     * Recalculate All Ratings
     * @returns AsyncJobResponse Successful Response
     * @throws ApiError
     */
    public static recalculateAllRatingsRatingsRecalculateAllPost(): CancelablePromise<AsyncJobResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/ratings/recalculate-all',
        });
    }
    /**
     * Initialize Session
     * Initializes a user session after authentication (OAuth or username/password).
     *
     * Checks if the authenticated user has a player record in the system:
     * - If player exists: returns access_token for standard login
     * - If player does not exist: returns onboarding_required flag to trigger onboarding flow
     *
     * @returns any Successful Response
     * @throws ApiError
     */
    public static initializeSessionSessionInitializePost(): CancelablePromise<(TokenResponse | OnboardingResponse)> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/session/initialize',
            errors: {
                401: `Unauthorized - invalid or missing authentication token`,
                500: `Server error`,
            },
        });
    }
    /**
     * Root
     * @returns any Successful Response
     * @throws ApiError
     */
    public static rootGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/',
        });
    }
    /**
     * Health Check
     * @returns any Successful Response
     * @throws ApiError
     */
    public static healthCheckHealthGet(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/health',
        });
    }
    /**
     * Record Telemetry Events
     * Store a batch of frontend usage events for the logged-in player. Identity comes from the token.
     * @returns TelemetryAccepted Successful Response
     * @throws ApiError
     */
    public static recordTelemetryEvents({
        requestBody,
    }: {
        requestBody: TelemetryEventBatch,
    }): CancelablePromise<TelemetryAccepted> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/telemetry/events',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                413: `Payload too large`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Upload Session Replay Chunk
     * Store one rrweb replay chunk for the logged-in player's session.
     * @returns TelemetryAccepted Successful Response
     * @throws ApiError
     */
    public static uploadTelemetryReplay({
        requestBody,
    }: {
        requestBody: TelemetryReplayChunk,
    }): CancelablePromise<TelemetryAccepted> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/telemetry/replay',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                413: `Payload too large`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Telemetry Preferences
     * @returns TelemetryPreferences Successful Response
     * @throws ApiError
     */
    public static getTelemetryPreferences(): CancelablePromise<TelemetryPreferences> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/telemetry/preferences',
        });
    }
    /**
     * Update Telemetry Preferences
     * @returns TelemetryPreferences Successful Response
     * @throws ApiError
     */
    public static updateTelemetryPreferences({
        requestBody,
    }: {
        requestBody: TelemetryPreferences,
    }): CancelablePromise<TelemetryPreferences> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/telemetry/preferences',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Usage Summary
     * Admin only. Aggregated usage over the last N days.
     * @returns UsageSummary Successful Response
     * @throws ApiError
     */
    public static getUsageSummary({
        days = 30,
    }: {
        days?: number,
    }): CancelablePromise<UsageSummary> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/telemetry/summary',
            query: {
                'days': days,
            },
            errors: {
                403: `Admin access required`,
            },
        });
    }
    /**
     * Usage Sessions
     * Admin only. Sessions in the last N days, newest first.
     * @returns UsageSession Successful Response
     * @throws ApiError
     */
    public static listUsageSessions({
        days = 7,
    }: {
        days?: number,
    }): CancelablePromise<Array<UsageSession>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/telemetry/sessions',
            query: {
                'days': days,
            },
            errors: {
                403: `Admin access required`,
            },
        });
    }
    /**
     * Player Activity Timeline
     * Admin only. Most recent events of one player, newest first.
     * @returns UsageEventRecord Successful Response
     * @throws ApiError
     */
    public static getPlayerUsageEvents({
        email,
        limit = 200,
    }: {
        email: string,
        limit?: number,
    }): CancelablePromise<Array<UsageEventRecord>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/telemetry/players/{email}/events',
            path: {
                'email': email,
            },
            query: {
                'limit': limit,
            },
            errors: {
                403: `Admin access required`,
            },
        });
    }
    /**
     * Session Replay
     * Admin only. All stored rrweb chunks of a session, in order.
     * @returns UsageReplay Successful Response
     * @throws ApiError
     */
    public static getSessionReplay({
        sessionId,
    }: {
        sessionId: string,
    }): CancelablePromise<UsageReplay> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/telemetry/sessions/{session_id}/replay',
            path: {
                'session_id': sessionId,
            },
            errors: {
                403: `Admin access required`,
                404: `Session not found`,
            },
        });
    }
}
